import React from "react";

const Bank = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
              d="M2 30.8h32V34H2v-3.2zM5.2 18h3.2v11.2H5.2V18zm8 0h3.2v11.2h-3.2V18zm6.4 0h3.2v11.2h-3.2V18zm8 0h3.2v11.2h-3.2V18zM2 10l16-8 16 8v6.4H2V10zm16 1.6a1.6 1.6 0 100-3.2 1.6 1.6 0 000 3.2z"
              fill={fill}/>
    </svg>
);

export default Bank;